import { navIndexReducer as navIndex } from './navModel';
import { appNotificationsReducer as appNotifications } from './appNotification';

export default {
  navIndex,
  appNotifications,
};
